<template>
  <div class="system-settings">
    <!-- 创建/编辑红包 -->
    <div class="settings-card" v-motion="{ initial: { opacity: 0, y: 16 }, animate: { opacity: 1, y: 0 }, transition: { duration: 0.3 } }">
      <h3>{{ editingId ? '编辑红包' : '创建红包' }}</h3>
      <div class="form-group">
        <label>标题</label>
        <input v-model="form.title" placeholder="请输入红包标题" maxlength="200" />
      </div>
      <div class="form-group">
        <label>内容</label>
        <textarea v-model="form.content" placeholder="请输入红包描述内容" rows="4"></textarea>
      </div>
      <div class="form-group">
        <label>最高金额（元）</label>
        <input v-model="form.maxAmount" type="number" step="0.01" min="0.01" placeholder="请输入最高金额" />
        <span class="hint">用户领取时将随机获得 0.01 ~ 最高金额 之间的金额</span>
      </div>
      <div class="form-group">
        <label>启用状态</label>
        <div class="switch-container">
          <label class="switch">
            <input type="checkbox" v-model="form.enabled" />
            <span class="slider"></span>
          </label>
          <span class="switch-label">{{ form.enabled ? '已启用' : '未启用' }}</span>
        </div>
      </div>
      <div class="form-actions">
        <button class="save-btn" @click="saveRedEnvelope" :disabled="saving">{{ saving ? '保存中...' : '保存' }}</button>
        <button class="cancel-btn" v-if="editingId" @click="resetForm">取消编辑</button>
      </div>
    </div>

    <!-- 红包列表 -->
    <div class="settings-card" v-motion="{ initial: { opacity: 0, y: 16 }, animate: { opacity: 1, y: 0 }, transition: { duration: 0.3, delay: 0.1 } }">
      <h3>红包列表</h3>
      <div v-if="loading" class="loading-text">加载中...</div>
      <div v-else-if="envelopes.length === 0" class="empty-text">暂无红包</div>
      <div v-else class="announcement-list">
        <div class="announcement-item" v-for="item in envelopes" :key="item.id">
          <div class="item-header">
            <span class="item-title">{{ item.title }}</span>
            <span :class="['status-badge', item.enabled ? 'enabled' : 'disabled']">{{ item.enabled ? '已启用' : '未启用' }}</span>
          </div>
          <div class="item-content">{{ item.content }}</div>
          <div class="item-meta">
            <span class="meta-tag">最高金额: ¥{{ item.maxAmount }}</span>
            <span class="meta-tag">已领取: {{ item.claimCount }}人</span>
          </div>
          <div class="item-actions">
            <button class="action-btn edit-btn" @click="editRedEnvelope(item)">编辑</button>
            <button class="action-btn toggle-btn" @click="toggleRedEnvelope(item)">{{ item.enabled ? '禁用' : '启用' }}</button>
            <button class="action-btn" @click="viewClaims(item)">领取记录</button>
            <button class="action-btn delete-btn" @click="deleteRedEnvelope(item)">删除</button>
          </div>
        </div>
      </div>
    </div>

    <!-- 领取记录弹窗 -->
    <transition name="modal-fade">
      <div class="claims-overlay" v-if="showClaims" @click.self="showClaims = false">
        <div class="claims-card">
          <div class="claims-header">
            <h3>领取记录 - {{ claimsTitle }}</h3>
            <button class="close-btn" @click="showClaims = false">&times;</button>
          </div>
          <div v-if="claimsLoading" class="loading-text">加载中...</div>
          <div v-else-if="claims.length === 0" class="empty-text">暂无领取记录</div>
          <div v-else class="claims-list">
            <div class="claim-item" v-for="claim in claims" :key="claim.id">
              <span class="claim-user">{{ claim.username }}</span>
              <span class="claim-amount">¥{{ claim.amount }}</span>
              <span class="claim-time">{{ formatTime(claim.claimedAt) }}</span>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { apiFetch } from '@/config/api'

export default {
  name: 'RedEnvelopeManagement',
  data() {
    return {
      form: {
        title: '',
        content: '',
        maxAmount: '',
        enabled: false
      },
      editingId: null,
      saving: false,
      loading: false,
      envelopes: [],
      // 领取记录
      showClaims: false,
      claimsTitle: '',
      claimsLoading: false,
      claims: []
    }
  },
  mounted() {
    this.loadRedEnvelopes()
  },
  methods: {
    async loadRedEnvelopes() {
      this.loading = true
      try {
        const res = await apiFetch('/api/red-envelope/list')
        if (res && res.code === 0) {
          this.envelopes = res.data || []
        }
      } catch (e) {
        console.error('加载红包失败', e)
      }
      this.loading = false
    },
    async saveRedEnvelope() {
      if (!this.form.title.trim()) {
        alert('请输入红包标题')
        return
      }
      if (!this.form.content.trim()) {
        alert('请输入红包内容')
        return
      }
      if (!this.form.maxAmount || parseFloat(this.form.maxAmount) < 0.01) {
        alert('请输入有效的最高金额（最小0.01）')
        return
      }
      this.saving = true
      try {
        const body = {
          title: this.form.title,
          content: this.form.content,
          maxAmount: parseFloat(this.form.maxAmount),
          enabled: this.form.enabled
        }
        if (this.editingId) {
          body.id = this.editingId
        }
        const res = await apiFetch('/api/red-envelope', {
          method: 'POST',
          body: JSON.stringify(body)
        })
        if (res && res.code === 0) {
          this.resetForm()
          this.loadRedEnvelopes()
        } else {
          alert(res.msg || '保存失败')
        }
      } catch (e) {
        alert('保存失败')
      }
      this.saving = false
    },
    editRedEnvelope(item) {
      this.editingId = item.id
      this.form.title = item.title
      this.form.content = item.content
      this.form.maxAmount = item.maxAmount
      this.form.enabled = item.enabled
    },
    async toggleRedEnvelope(item) {
      try {
        const res = await apiFetch('/api/red-envelope/' + item.id + '/toggle', {
          method: 'PUT'
        })
        if (res && res.code === 0) {
          this.loadRedEnvelopes()
        } else {
          alert(res.msg || '操作失败')
        }
      } catch (e) {
        alert('操作失败')
      }
    },
    async deleteRedEnvelope(item) {
      if (!confirm('确定删除该红包吗？删除后领取记录也将丢失。')) return
      try {
        const res = await apiFetch('/api/red-envelope/' + item.id, {
          method: 'DELETE'
        })
        if (res && res.code === 0) {
          if (this.editingId === item.id) {
            this.resetForm()
          }
          this.loadRedEnvelopes()
        } else {
          alert(res.msg || '删除失败')
        }
      } catch (e) {
        alert('删除失败')
      }
    },
    async viewClaims(item) {
      this.claimsTitle = item.title
      this.showClaims = true
      this.claimsLoading = true
      try {
        const res = await apiFetch('/api/red-envelope/' + item.id + '/claims')
        if (res && res.code === 0) {
          this.claims = res.data || []
        }
      } catch (e) {
        console.error('加载领取记录失败', e)
      }
      this.claimsLoading = false
    },
    formatTime(timeStr) {
      if (!timeStr) return ''
      return timeStr.replace('T', ' ').substring(0, 19)
    },
    resetForm() {
      this.editingId = null
      this.form.title = ''
      this.form.content = ''
      this.form.maxAmount = ''
      this.form.enabled = false
    }
  }
}
</script>

<style scoped>
.system-settings {
  padding: 0;
}

.settings-card {
  background: #fff;
  padding: 24px;
  border: 1px solid #e8e8e8;
  max-width: 500px;
  margin-bottom: 16px;
}

.settings-card h3 {
  margin: 0 0 20px;
  font-size: 15px;
  font-weight: 600;
  color: #111;
}

.form-group {
  margin-bottom: 16px;
}

.form-group label {
  display: block;
  margin-bottom: 6px;
  font-size: 13px;
  color: #666;
}

.form-group input {
  width: 100%;
  height: 38px;
  padding: 0 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  box-sizing: border-box;
}

.form-group textarea {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  box-sizing: border-box;
  resize: vertical;
  font-family: inherit;
  line-height: 1.6;
}

.form-group input:focus,
.form-group textarea:focus {
  outline: none;
  border-color: #111;
}

.form-group .hint {
  display: block;
  margin-top: 4px;
  font-size: 12px;
  color: #999;
}

.switch-container {
  display: flex;
  align-items: center;
  gap: 10px;
}

.switch {
  position: relative;
  display: inline-block;
  width: 44px;
  height: 24px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  inset: 0;
  background: #ccc;
  border-radius: 24px;
  transition: 0.2s;
}

.slider:before {
  content: "";
  position: absolute;
  height: 18px;
  width: 18px;
  left: 3px;
  bottom: 3px;
  background: #fff;
  border-radius: 50%;
  transition: 0.2s;
}

.switch input:checked + .slider {
  background: #e53935;
}

.switch input:checked + .slider:before {
  transform: translateX(20px);
}

.switch-label {
  font-size: 13px;
  color: #666;
}

.form-actions {
  display: flex;
  gap: 10px;
}

.save-btn {
  background: #e53935;
  color: #fff;
  border: none;
  padding: 9px 20px;
  border-radius: 4px;
  font-size: 13px;
  cursor: pointer;
  font-weight: 500;
}

.save-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.cancel-btn {
  background: none;
  color: #666;
  border: 1px solid #ddd;
  padding: 9px 20px;
  border-radius: 4px;
  font-size: 13px;
  cursor: pointer;
}

.cancel-btn:hover {
  border-color: #111;
  color: #111;
}

.loading-text,
.empty-text {
  font-size: 13px;
  color: #999;
  text-align: center;
  padding: 20px 0;
}

.announcement-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.announcement-item {
  border: 1px solid #eee;
  border-radius: 6px;
  padding: 14px;
}

.item-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}

.item-title {
  font-size: 14px;
  font-weight: 500;
  color: #111;
}

.status-badge {
  font-size: 12px;
  padding: 2px 8px;
  border-radius: 10px;
}

.status-badge.enabled {
  background: #fce4ec;
  color: #c62828;
}

.status-badge.disabled {
  background: #f5f5f5;
  color: #999;
}

.item-content {
  font-size: 13px;
  color: #666;
  line-height: 1.5;
  margin-bottom: 8px;
  white-space: pre-wrap;
  word-break: break-word;
  max-height: 60px;
  overflow: hidden;
}

.item-meta {
  display: flex;
  gap: 12px;
  margin-bottom: 10px;
}

.meta-tag {
  font-size: 12px;
  color: #e53935;
  background: #fce4ec;
  padding: 2px 8px;
  border-radius: 4px;
}

.item-actions {
  display: flex;
  gap: 8px;
}

.action-btn {
  font-size: 12px;
  padding: 4px 12px;
  border-radius: 4px;
  cursor: pointer;
  border: 1px solid #ddd;
  background: none;
  color: #666;
  transition: all 0.15s;
}

.action-btn:hover {
  border-color: #111;
  color: #111;
}

.delete-btn:hover {
  border-color: #e53935;
  color: #e53935;
}

/* 领取记录弹窗 */
.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.25s ease;
}
.modal-fade-enter-from,
.modal-fade-leave-to {
  opacity: 0;
}

.claims-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 20px;
}

.claims-card {
  background: #fff;
  border-radius: 12px;
  padding: 24px;
  max-width: 420px;
  width: 100%;
  max-height: 70vh;
  overflow-y: auto;
  position: relative;
}

.claims-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}

.claims-header h3 {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: #111;
}

.close-btn {
  background: none;
  border: none;
  font-size: 22px;
  color: #999;
  cursor: pointer;
  line-height: 1;
  padding: 4px;
}

.close-btn:hover {
  color: #333;
}

.claims-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.claim-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 12px;
  background: #fafafa;
  border-radius: 6px;
  font-size: 13px;
}

.claim-user {
  color: #333;
  font-weight: 500;
  flex: 1;
}

.claim-amount {
  color: #e53935;
  font-weight: 600;
  margin: 0 12px;
}

.claim-time {
  color: #999;
  font-size: 12px;
}
</style>
